import type { NguoiDungRutGon } from '../types.ts';

export interface TuyChonNguoi {
  value: string;
  /** Chuỗi để lọc tại chỗ và để ô hiện tên khi đã chọn. */
  label: string;
  /** Mã của dòng không có tên, chỉ để rê chuột xem. */
  title?: string;
}

/** Một dòng của ô chọn người: `Tên · email`, không tên thì email, không cả hai thì `khongRoTen`. Không bao giờ in mã. */
export function tuyChonNguoi(u: NguoiDungRutGon, khongRoTen: string): TuyChonNguoi {
  const ten = u.display_name?.trim();
  if (ten) return { value: u.user_id, label: u.email ? `${ten} · ${u.email}` : ten };
  return u.email ? { value: u.user_id, label: u.email } : { value: u.user_id, label: khongRoTen, title: u.user_id };
}

/**
 * Dòng cho `value` đang lọc mà danh sách không có: người đã rời, danh sách lỗi, hoặc đã tìm sang người khác. Thiếu dòng này
 * thì ô chọn in nguyên `value` là UUID. Trả `null` khi không lọc hoặc đã có trong danh sách.
 */
export function tuyChonNgoaiDanhSach(
  value: string | undefined,
  danhSach: readonly NguoiDungRutGon[],
  tenDaBiet: string | null | undefined,
  khongRoTen: string,
): TuyChonNguoi | null {
  if (!value || danhSach.some((u) => u.user_id === value)) return null;
  return tenDaBiet ? { value, label: tenDaBiet, title: value } : { value, label: khongRoTen, title: value };
}
